import request from '@/services/base/request'

export default {
  loadNotifications: (data: any) => request('/notifications/' + data.query, 'get', data.payload),
  readNotification: (data: any) => request(`/notifications/${data.notificationId}/`, 'post', data.payload)
}
